import React from "react";
import PropTypes from "prop-types";
import styles from "./style/CartCard.module.css";
import clsx from "clsx";
import { Card } from "react-bootstrap";
import { DEFAULT_IMAGE_SRC } from "@constants";
import { Link, useNavigate } from "react-router-dom";
import { ConfirmModal } from "../ConfirmModal/ConfirmModal";
import { replaceErrorImage } from "@helpers";

const CartCard = ({ variant, data, handleDelete, moveTo }) => {
  // hooks
  const navigate = useNavigate();
  // variables
  const { id, title, category, price, priceDiscount, thumbnailUrl, author } =
    data;
  let imageUrl = DEFAULT_IMAGE_SRC;
  // UI partials

  // logics

  /* TODO: update logic for getting imageUrl */
  if ((thumbnailUrl ?? "string") !== "string") imageUrl = thumbnailUrl;

  const viewDetails = () => {
    if (id) navigate(`/course/${id}`);
    else navigate("/404");
  };

  //effects
  //render
  return (
    <Card
      className={clsx(styles.courseCard, "p-2", {
        [styles.courseCardHorizontal]: variant === "horizontal",
      })}
    >
      <div className={clsx(styles.cardImg, "position-relative")}>
        <div className={styles.cardImgWrapper}>
          <Card.Img variant="top" src={imageUrl} onError={replaceErrorImage} />
          <div className={styles.cardOverlay}></div>
        </div>
        {/* <button
          className={clsx(styles.playIcon, "position-absolute")}
          onClick={viewDetails}
        >
          <i className="bi bi-play"></i>
        </button> */}
      </div>
      <Card.Body className={styles.cardBody}>
        <div>
          <div className={clsx(styles.titleContainer)}>
            <Card.Title
              className={clsx(styles.courseTitle, "h6")}
              onClick={viewDetails}
            >
              {title}
            </Card.Title>
            <ConfirmModal
              onSubmit={handleDelete}
              title="Delete Course"
              submitButton="Delete"
              body="Are you sure to delete this course?"
            >
              <i
                className="bi bi-x-lg"
                // onClick={() => {
                //   onShowDelete();
                // }}
              ></i>
            </ConfirmModal>
            {/* <i
              className="bi bi-x-lg"
              onClick={() => {
                onShowDelete();
              }}
            ></i> */}
          </div>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <span className={clsx(styles.fs12)}>
              {category?.name || "Unknown category"}
            </span>
          </div>
          <div className={clsx(styles.fs12, "mt-2")}>
            <div>
              <span>By </span>
              {author ? <Link to="/">{author.fullName}</Link> : "Unknow author"}
            </div>

            <div className={clsx(styles.priceText)}>
              {priceDiscount !== price ? (
                <div className={clsx(styles.discountAppear)}>
                  <span>{`${priceDiscount.toFixed(2)}`}</span>
                  <span className={clsx(styles.oldPrice)}>{price}</span>
                </div>
              ) : (
                price
              )}
            </div>
            {/* </div> */}
          </div>
        </div>
        {/* <div> */}

        <div className={clsx(styles.btnMove)}>{moveTo()}</div>
      </Card.Body>
    </Card>
  );
};

/* required: display name */
CartCard.displayName = "CartCard";

/* required: props types */
CartCard.propTypes = {
  variant: PropTypes.oneOf(["vertical", "horizontal"]),
  data: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    category: PropTypes.shape({ id: PropTypes.string, name: PropTypes.string }),
    createdAt: PropTypes.string,
    price: PropTypes.number,
    discountPrice: PropTypes.number,
    thumbnailUrl: PropTypes.string,
    author: PropTypes.shape({
      fullName: PropTypes.string,
      link: PropTypes.string,
      //   email: PropTypes.string,
    }),
  }),
  handleDelete: PropTypes.func,
  moveTo: PropTypes.func,
};

/* required: default props */
CartCard.defaultProps = {
  variant: "vertical",
  //   data: {
  //     title: "Unknown title",
  //     category: { name: "Unknown category" },
  //     createdAt: moment(),
  //     price: 0,
  //     thumbnailUrl: DEFAULT_IMAGE_SRC,
  //     author: { fullName: "Unknown author" },
  //   },
};

export { CartCard };
